import * as React from "react";
import { TextField } from "@mui/material";
import NumberFormat from "react-number-format";

import {setErrors} from "../Store/roiStore";

export const InputField = ({
  placeholder,
  defaultValue,
  onValueInputChange,
  label,
  type,
  prefix,
  suffix,
  hidden,
  ...rest
}) => {
  const isNumber = type === "number";
  const onChange = ({ name, value }) => {
    if (!onValueInputChange) return;
    onValueInputChange(name, value);
  };

  if (hidden) return <div></div>
  return isNumber ? (
    <NumberFormat
      label={label}
      id="filled-size-small"
      defaultValue={defaultValue}
      variant="filled"
      size="small"
      onFocus={(event) => {
        event.target.select();
      }}
      placeholder={placeholder}
      allowNegative={false}
      {...rest}
      customInput={TextField}
      prefix={prefix}
      suffix={suffix}
      type="text"
      thousandSeparator={","}
      onValueChange={(values, sourceInfo) =>
        onChange({ name: label, value: values.value ?? 0 })
      }
    />
  ) : (
    <TextField
      label={label}
      id="filled-size-small"
      defaultValue={defaultValue}
      variant="filled"
      size="small"
      placeholder={placeholder}
      onChange={(event) =>
        onChange({ name: label, value: event.target.value ?? "" })
      }
      {...rest}
    />
  );
};
